import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Inventory } from '../models/inventory.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  private apiUrl = `${environment.apiUrl}/inventory`;

  private categoryUrl = `${environment.apiUrl}/InventoryCategory`;
  constructor(private http: HttpClient) {}

  getAll(): Observable<Inventory[]> {
    return this.http.get<Inventory[]>(this.apiUrl);
  }

  getById(id: number): Observable<Inventory> {
    return this.http.get<Inventory>(`${this.apiUrl}/${id}`);
  }

  create(payload: any) {
    return this.http.post(`${this.apiUrl}`, payload);
  }

  update(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, payload);
  }

  delete(id: number) {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  bulkCreate(items: any[]) {
    return this.http.post<void>(`${this.apiUrl}/bulk`, items);
  }

  getBooks() {
    return this.http.get<{ id: number; title: string; isbn: string }[]>(
      `${this.apiUrl}/books`,
    );
  }

  getCategories() {
    return this.http.get<any[]>(this.categoryUrl);
  }

  createCategory(name: string) {
    return this.http.post<any>(this.categoryUrl, { name });
  }

  deleteCategory(id: number) {
    return this.http.delete(`${this.categoryUrl}/${id}`);
  }

  checkSerialExists(serial: string, ignoreId?: number) {
    const params: any = { serial };
    if (ignoreId != null) params.ignoreId = String(ignoreId);
    return this.http.get<boolean>(`${this.apiUrl}/exists-serial`, { params });
  }

  getSerialNumbers() {
    return this.http.get<string[]>(`${this.apiUrl}/serial-numbers`);
  }

  exportInventoryPdf(inventoryIds: number[]) {
    return this.http.post(
      `${this.apiUrl}/export/pdf`,
      { inventoryIds },
      { responseType: 'blob' },
    );
  }
  getInventoryStatuses() {
    return this.http.get<{ code: string; name: string }[]>(
      `${this.apiUrl}/statuses`,
    );
  }
  bulkCreateWithFile(file: File, items: any[]) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('items', JSON.stringify(items));

    return this.http.post(`${this.apiUrl}/bulk-with-file`, formData);
  }
}
